import { useEffect, useState } from 'react';
import type { CashSessionRow } from '../../infra/cashSessionsRepo';
import { getCashSessionDetailRemoteFirst, type CashSessionDetail } from '../../infra/cashSummaryQuery';

type State = {
  detail: CashSessionDetail | null;
  loading: boolean;
};

const EMPTY_DETAIL: CashSessionDetail = {
  salesCount: 0,
  salesTotal: 0,
  outflowsTotal: 0,
  inflowsTotal: 0,
  paymentBreakdown: [],
};

export function useCashSessionDetail(session: CashSessionRow | null, enabled: boolean) {
  const [state, setState] = useState<State>({ detail: null, loading: false });

  useEffect(() => {
    if (!session || !enabled) {
      setState({ detail: null, loading: false });
      return;
    }

    let cancelled = false;
    setState({ detail: null, loading: true });

    void getCashSessionDetailRemoteFirst({ id: session.id, openedAt: session.openedAt })
      .then((detail) => {
        if (!cancelled) setState({ detail, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ detail: EMPTY_DETAIL, loading: false });
      });

    return () => {
      cancelled = true;
    };
  }, [session?.id, session?.openedAt, enabled]);

  return state;
}
